import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { CookiesProvider } from 'react-cookie';

import { library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

import SEO from '../SEO/SEO';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

library.add(fab, fas);

// ====

const Layout = (props) => {
  const { children, meta, settings, mode, openGraph } = props;

  let siteSettings = null;

  if (mode === 'editor') {
    siteSettings = settings;
  } else {
    const siteData = useStaticQuery(graphql`
      {
        storyblokEntry(slug: { eq: "settings" }) {
          content
        }
      }
    `);

    siteSettings = JSON.parse(siteData.storyblokEntry.content);
  }
  return (
    <CookiesProvider>
      <SEO
        meta={meta}
        settings={siteSettings}
        openGraph={openGraph}
        mode="debug"
      />
      <Header mode={mode} settings={siteSettings} />
      {children}
      <Footer mode={mode} settings={siteSettings} />
    </CookiesProvider>
  );
};

export default Layout;

// ====

Layout.propTypes = {
  settings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  meta: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mode: PropTypes.string,
  children: PropTypes.node.isRequired,
};

Layout.defaultProps = {
  settings: null,
  meta: null,
  mode: 'normal',
};
